import * as React from 'react'
import { StyleSheet, ScrollView, View, Dimensions } from 'react-native'
import { Card, Title, Paragraph } from 'react-native-paper'
import { AntDesign as Icon } from '@expo/vector-icons'
import dayjs from 'dayjs'

import useColorScheme from '../../hooks/useColorScheme'
import { selectCalendar, Commit } from '../../redux/selectors'
import Calendar from './Calendar'
import Screen from '../../components/Screen'
import { useAppSelector, useMinutesToStatsTime, useMsToMinutes } from '../../hooks'
import { selectStreak, selectTotalDuration, selectTotalSessions, selectCommits } from '../../redux/selectors'
import ManualEntry from './ManualEntry'
import { useThemeColor } from '../../components'
import {
  BarChart, ContributionGraph
} from "react-native-chart-kit"

export default function StatsScreen() {
  //Component key will redraw calendars color switch issue.
  const calendar = useAppSelector(selectCalendar)
  const colorScheme = useColorScheme()
  const totalSessions = useAppSelector(selectTotalSessions)
  const totalDuration = useAppSelector(selectTotalDuration)
  const commits = useAppSelector(selectCommits)
  const streak = useAppSelector(selectStreak)
  const totalMinutes = useMsToMinutes(totalDuration)
  const listenedStat = useMinutesToStatsTime(totalMinutes)
  const primary = useThemeColor({}, 'primary')
  const [manualEntryTimestamp, setManualEntryTimestamp] = React.useState<number>()
  const white = useThemeColor({}, 'white')
  const textColor = useThemeColor({}, 'text')
  //const { quote, author } = useQuote()

  const daysData = () => { 
    let days: number[] = []
    let labelData: string[] = []

    for(let n = 0; n <= 14; n++){
      let date = dayjs((Date.now() - (14 * 86400000)) + (86400000 * n)).format('YYYY-MM-DD')
      let commit = commits.find((commit) => commit.date === date)
      labelData.push(date)
      if (commit)
      {
        days.push(commit.duration)
      }
      else
      {
        days.push("")
      }
    }

    let data = {
      labels: labelData,
      datasets: [
        {
          data: days
        }
      ]
    }

    return data
  }

  const commitsData = () => { 
    return commits
  }

  const chartWidth = 100;

  const chartConfig = {
    backgroundGradientFrom: white,    
    backgroundGradientFromOpacity: 1,
    backgroundGradientTo: white,
    backgroundGradientToOpacity: 1,
    //color: () => `${primary}`,
    fontFamily: 'space-mono',
    color: (opacity = 1) => `rgba(70,130,180, ${opacity})`,
    labelColor: () => `${textColor}`,
    strokeWidth: 3, // optional, default 3
    barPercentage: 0.5,
    decimalPlaces: 0,
    avoidFalseZero: true,    
    //paddingRight: 50,
    //hasLegend: true,
    onDayPress: () => {console.log("daypress")}
  };

  return (
    <>
      <Screen scroll 
      //style={{marginTop: -10}}
      >
        {/*<ScrollView horizontal showsHorizontalScrollIndicator={false}>
          <Card style={styles.card}>
            <Card.Content style={styles.cardContent}>
              <Icon name="calendar" style={styles.icon} size={30} color={primary} />
              <Paragraph>{totalSessions}</Paragraph>
              <Title>
                Sessions
              </Title>
            </Card.Content>
          </Card>
          <Card style={styles.thinCard}>
            <Card.Content style={styles.cardContent}>
              <Icon name="Trophy" style={styles.icon} size={30} color={primary} />
              <Paragraph>{streak} day{streak === 1 ? '' : 's'}</Paragraph>
              <Title>
                Streak
              </Title>
            </Card.Content>
          </Card>
          <Card style={styles.thickCard}>
            <Card.Content style={styles.cardContent}>
              <Icon name="clockcircleo" style={styles.icon} size={30} color={primary} />
              <Paragraph>{listenedStat}</Paragraph>
              <Title>Spent</Title>
            </Card.Content>
          </Card>
        </ScrollView>
  */}
        <Card
            style={{
              borderRadius: 16,
              marginBottom: 10,
              marginRight: 16,
              paddingLeft: 16,
            }}>
          <Card.Content style={{
            }}>
            <ScrollView horizontal showsHorizontalScrollIndicator={false} >
              <Icon name="Trophy" style={styles.icon} size={30} color={primary} />  
              <Title>  {streak} day{streak === 1 ? '' : 's'} streak</Title>
            </ScrollView>
            <ScrollView horizontal showsHorizontalScrollIndicator={false} >
              <Icon name="calendar" style={styles.icon} size={30} color={primary} />  
              <Title>  {totalSessions} session{totalSessions === 1 ? '' : 's'}</Title>
            </ScrollView>
            <ScrollView horizontal showsHorizontalScrollIndicator={false} style={{}}>
              <Icon name="clockcircleo" style={styles.icon} size={30} color={primary} />  
              <Title>  {listenedStat}</Title>
            </ScrollView>
          </Card.Content>
        </Card>

        <ScrollView horizontal showsHorizontalScrollIndicator={false}>
          <ContributionGraph
            values={commitsData()}
            endDate={new Date()}
            numDays={105}
            squareSize={19}
            width={Dimensions.get("window").width - 30} 
            height={220}
            chartConfig={chartConfig}
            style={{
              borderRadius: 16,
              marginBottom: 10
            }}
          />
        </ScrollView>
        <ScrollView horizontal showsHorizontalScrollIndicator={false}>
          <BarChart
            //style={graphStyle}
            data={daysData()}
            width={Dimensions.get("window").width - 30} // from react-native
            height={220}
            //chartConfig={chartConfig}
            //withHorizontalLabels={false}
            withVerticalLabels={false}
            fromZero={true}
            withInnerLines={false}
            showValuesOnTopOfBars={true}
            //paddingRight={-50}
            chartConfig={chartConfig}
            style={{
              borderRadius: 16,
              marginBottom: 10,
              paddingRight: 10
              
            }}
          />
        </ScrollView>
        <Calendar key={colorScheme} setManualEntryTimestamp={setManualEntryTimestamp} />
        {/*<View style={styles.quoteContainer}>
          <Card style={styles.quoteCard}>
            <Card.Content style={styles.cardContent}>
              <Title style={styles.quoteTitle}>{quote}</Title>
            </Card.Content>
          </Card>
  </View>*/}
      </Screen>
      <View pointerEvents="box-none" style={StyleSheet.absoluteFill}>
        <ManualEntry
          timestamp={manualEntryTimestamp}
          onDismiss={() => setManualEntryTimestamp(undefined)}
        />
      </View>
    </>
  )
}

const styles = StyleSheet.create({
  card: {
    width: 118,
    marginRight: 8,
    textAlign: 'center',
    marginBottom: 10,
    borderRadius: 16,
  },
  thinCard: {
    width: 100,
    marginRight: 8,
    textAlign: 'center',
    marginBottom: 10,
    borderRadius: 16,
  },
  thickCard: {
    width: 128,
    marginRight: 8,
    textAlign: 'center',
    marginBottom: 10,
    borderRadius: 16,
  },
  quoteContainer: { marginRight: 10, marginBottom: 30 },
  quoteCard: {
    width: '100%',
  },
  quoteTitle: {
    textAlign: 'center',
  },
  cardContent: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    marginBottom: 10,
  },
})
